import React, { useEffect, useState } from "react";
import {
  Button,
  Table,
  Tag,
  Popconfirm,
  Modal,
  message,
  Select,
  notification,
  Spin,
} from "antd";
import { useLoading } from "../../context/loadingContext";
import GetSettleTransaction from "../../functions/merchant/getSettleTransactions";
import moneyFormat from "../../functions/utils/moneyFormat";
import dayjs from "dayjs";
import ForceSettle from "../../functions/merchant/forceSettle";
import GetIncomeTransaction from "../../functions/merchant/getIncomeTransaction";
import SettleTransaction from "../../functions/merchant/settleTransaction";
import { TransactionOutlined } from "@ant-design/icons";
import { bg_button, bg_shadow, bg_text } from "constant/css";
import CheckPermission from "functions/utils/checkPermission";
import BankSelectModal from "./bankSelectModal";
import UpdateTransactionBank from "functions/merchant/updateTransactionBank";
import { parklyLogin } from "functions/parkly/login";
import { parklyPaymentSummary } from "functions/parkly/paymentSummary";
const title = (title) => (
  <span className={`text-xs text-center  font-bold text-gray-800`}>
    {title}
  </span>
);
const SettleTransactions = ({
  open,
  close,
  refresh,
  defaultMerchantId = null,
}) => {
  const merchantSettleId = open;
  const { showLoading, hideLoading } = useLoading();
  const [data, setData] = useState([]);
  const [defaultData, setDefaultData] = useState([]);
  const [incomeData, setIncomeData] = useState([]);
  const [uniqueAccountNames, setUniqueAccountNames] = useState([]);
  const [pickBankTran, setPickBankTran] = useState(null);
  const merchantId = defaultMerchantId || localStorage.getItem("merchantId");
  const [parklyData, setParklyData] = useState(null);
  const [filteredParklyData, setFilteredParklyData] = useState(null);
  const [loadingParkly, setLoadingParkly] = useState(false);
  const [parklyDetailOpen, setParklyDetailOpen] = useState(false);
  useEffect(() => {
    if (merchantSettleId) fetchTransactions();
    // eslint-disable-next-line
  }, [merchantSettleId]);
  const showEditTransaction = (e) => {
    setPickBankTran(e);
  };
  const closeEdit = () => {
    setPickBankTran(null);
  };
  const filterAccountName = (value) => {
    if (value) {
      const filteredData = defaultData.filter(
        (item) => item.toAccountName === value,
      );
      setData(filteredData);
      if (parklyData && filteredData[0]) {
        const account = filteredData[0].accountNumber;
        const accountDetail = parklyData.detailsByAccount?.[account] || {};
        setFilteredParklyData({
          ...accountDetail,
          total: parklyData.byAccounts[account] || 0,
          byAccounts: {
            [account]: parklyData.byAccounts[account] || 0,
          },
        });
      }
    }
  };
  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      width: "4%",
    },
    {
      title: title("Нийт дүн"),
      dataIndex: "amount",
      key: "amount",
      width: 30,
      render: (e) => moneyFormat(e),
    },
    {
      title: title("Шилжүүлэх"),
      dataIndex: "fromAccountNumber",
      key: "fromAccountNumber",
      width: 100,
    },
    {
      title: title("Хүлээн авах"),
      dataIndex: "accountNumber",
      key: "accountNumber",
      width: 105,
    },
    {
      title: (
        <div className="w-[120px] px-2">
          {title("Хүлээн авагч")}
          <Select
            onChange={filterAccountName}
            className="w-full mt-1"
            size="small"
          >
            {uniqueAccountNames.map((name) => (
              <Select.Option key={name} value={name}>
                {name}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      dataIndex: "toAccountName",
      key: "toAccountName",
      width: 130,
      render: (e, r) =>
        e === "Байгууллага олдсонгүй" ? (
          <Tag
            color="red"
            onClick={() => showEditTransaction(r)}
            className="cursor-pointer"
          >
            {/* <span className="text-red-500 text-xs">{e}</span> */}
            Банк сонгоx
          </Tag>
        ) : (
          <span className="text-gray-700 text-xs">{e}</span>
        ),
    },
    {
      title: title("Төлөв"),
      dataIndex: "status",
      key: "status",
      width: 80,
      render: (e) =>
        e === "SETTLED" ? (
          <Tag color={"cyan"} className="text-xs">
            {"Шилжүүлсэн"}
          </Tag>
        ) : (
          <Tag color={"default"} className="text-xs">
            {"Хүлээгдэж байна"}
          </Tag>
        ),
    },
    {
      title: title("Огноо"),
      dataIndex: "settledAt",
      key: "settledAt",
      width: 115,
      render: (e) => (
        <span className="text-xs">
          {e ? dayjs(e).format("YYYY-MM-DD HH:mm") : ""}
        </span>
      ),
    },
    {
      title: title("Ш/дугаар"),
      dataIndex: "journalNo",
      key: "journalNo",
      width: 95,
    },
    {
      title: title("Meрчант %"),
      dataIndex: "merchantFeePercent",
      key: "merchantFeePercent",
      width: 85,
    },
    {
      title: title("Meрчант дүн"),
      dataIndex: "merchantFee",
      key: "merchantFee",
      width: 85,
    },
    {
      title: title("xPay %"),
      dataIndex: "xpayFeePercent",
      key: "xpayFeePercent",
      width: 85,
    },
    {
      title: title("xPay дүн"),
      dataIndex: "xpayFee",
      key: "xpayFee",
      width: 85,
      render: (e) => <span className="text-orange-500">{moneyFormat(e)}</span>,
    },
    {
      title: title("процэсс %"),
      dataIndex: "processingFeePercent",
      key: "processingFeePercent",
      width: 85,
    },
    {
      title: title("процэсс дүн"),
      dataIndex: "processingFee",
      key: "processingFee",
      width: 90,
      render: (e) => <span className="text-orange-700">{moneyFormat(e)}</span>,
    },
    {
      title: title("Эцсийн дүн"),
      dataIndex: "afterFeeAmount",
      key: "afterFeeAmount",
      width: 85,
      render: (e) => <span className={`${bg_text}`}>{moneyFormat(e)}</span>,
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      width: 60,
    },
  ];
  const incomeColumns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      width: "4%",
    },
    {
      title: "Нийт дүн",
      dataIndex: "amount",
      key: "amount",
      width: 35,
      render: (e) => moneyFormat(e),
    },
    {
      title: "Аль данснаас",
      dataIndex: "fromAccountNumber",
      key: "fromAccountNumber",
      width: "10%",
    },
    {
      title: "Дансруу",
      dataIndex: "accountNumber",
      key: "accountNumber",
      width: "10%",
    },
    {
      title: "Хүлээн авагч",
      dataIndex: "toAccountName",
      key: "toAccountName",
      width: "15%",
      render: (e) => <span className="text-gray-700 text-xs">{e}</span>,
    },
    {
      title: "Төлөв",
      dataIndex: "status",
      key: "status",
      width: "12%",
      render: (e) =>
        e === "SETTLED" ? (
          <Tag color={"cyan"}>{"Шилжүүлсэн"}</Tag>
        ) : (
          <Tag color={"default"}>{"Хүлээгдэж байна"}</Tag>
        ),
    },
    {
      title: "Шилжүүлсэн огноо",
      dataIndex: "settledAt",
      key: "settledAt",
      width: "15%",
      render: (e) => (e ? dayjs(e).format("YYYY-MM-DD HH:mm") : ""),
    },
    {
      title: "Ш/дугаар",
      dataIndex: "journalNo",
      key: "journalNo",
      width: "8%",
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      width: "5%",
    },
  ];
  const fetchTransactions = async () => {
    showLoading();
    const response = await GetSettleTransaction(merchantId, merchantSettleId);
    const incomeResponse = await GetIncomeTransaction(
      merchantId,
      merchantSettleId,
    );
    if (incomeResponse.success) setIncomeData(incomeResponse.data);
    if (response.success) {
      setDefaultData(
        response.data.map((e) => {
          return {
            ...e,
            action: (
              <CheckPermission allow={3}>
                <Popconfirm
                  title="bitgii dar"
                  disabled={e.status === "SETTLED"}
                  okText="forceSettle"
                  onConfirm={() => settleTransaction(e.id)}
                >
                  <Button
                    disabled={e.status === "SETTLED"}
                    icon={<TransactionOutlined style={{ color: "#fff" }} />}
                    className={`${bg_button} hover:bg-blue-700 border-none`}
                  />
                </Popconfirm>
              </CheckPermission>
            ),
          };
        }),
      );
      setData(
        response.data.map((e) => {
          return {
            ...e,
            action: (
              <CheckPermission allow={3}>
                <Popconfirm
                  title="bitgii dar"
                  disabled={e.status === "SETTLED"}
                  okText="forceSettle"
                  onConfirm={() => settleTransaction(e.id)}
                >
                  <Button
                    disabled={e.status === "SETTLED"}
                    icon={<TransactionOutlined style={{ color: "#fff" }} />}
                    className={`${bg_button} hover:bg-blue-700 border-none`}
                  />
                </Popconfirm>
              </CheckPermission>
            ),
          };
        }),
      );
      setUniqueAccountNames([
        ...new Set(response.data.map((e) => e.toAccountName)),
      ]);
    }
    if (response.data && response.data.length > 0 && Number(merchantId) === 1) {
      setLoadingParkly(true);
      const uniqueAccounts = [
        ...new Set(response.data.map((e) => e.accountNumber)),
      ];
      const pData = {
        total: 0,
        byAccounts: {},
        detailsByAccount: {},
        cash_total: 0,
        grand_total: 0,
        pos_total: 0,
        smartpay_total: 0,
        spay_grand_total: 0,
        total_transactions: 0,
      };
      for await (const account of uniqueAccounts) {
        const parklyDate = dayjs(response.data[0].createdAt).format(
          "YYYY-MM-DD",
        );
        const data = await fetchParklyAmount(account, parklyDate);
        pData.detailsByAccount[account] = data || {};
        pData.cash_total += Number(data?.cash_total || 0);
        pData.grand_total += Number(data?.grand_total || 0);
        pData.pos_total += Number(data?.pos_total || 0);
        pData.smartpay_total += Number(data?.smartpay_total || 0);
        pData.spay_grand_total += Number(data?.spay_grand_total || 0);
        pData.total_transactions += Number(data?.total_transactions || 0);
        const totalXpay = Number(data?.spay_grand_total || 0);
        console.log("account:", account, data);
        if (totalXpay) {
          pData.byAccounts[account] = totalXpay;
          pData.total += totalXpay;
        }
      }
      console.log("parklyData:", pData);
      setParklyData(pData);
      setFilteredParklyData(pData);
      setLoadingParkly(false);
    }
    hideLoading();
  };

  const settleTransaction = async (tranId) => {
    showLoading();
    const response = await SettleTransaction(tranId);
    if (response && response.success) fetchTransactions();
    hideLoading();
  };

  const forceSettle = async () => {
    showLoading();
    const response = await ForceSettle(merchantId, merchantSettleId);
    hideLoading();
    if (response) {
      message.success("Амжилттай өндөрлөө");
      refresh();
      fetchTransactions();
      //close();
    }
  };
  const saveTransaction = async (bankCode) => {
    showLoading();
    console.log("pickBankTran:", pickBankTran, bankCode);
    const response = await UpdateTransactionBank(pickBankTran.id, bankCode);
    hideLoading();
    if (response && response.success) {
      message.success("Амжилттай солигдлоо");
      fetchTransactions();
      closeEdit();
    } else {
      message.error("Алдаа гарлаа");
    }
  };
  const fetchParklyAmount = async (account, date) => {
    try {
      const token = await parklyLogin();
      if (!token)
        return notification.error({
          message: "Parkly token-ийг авахад алдаа гарлаа",
        });

      const data = await parklyPaymentSummary(token, account, date);
      return data.data;
    } catch (e) {
      console.log("fetchParklyAmount error:", e);
    }
  };

  return (
    <Modal
      title={
        <span className={`text-xl font-bold text-gray-800 ${bg_text}`}>
          Мерчант гүйлгээ
        </span>
      }
      open={open}
      width={"90%"}
      onCancel={close}
      footer={null}
      className="!p-0"
      style={{ top: 20 }} // <-- sets top position
      bodyStyle={{ padding: 0 }}
    >
      <div className="p-2">
        <div className={`rounded-xl`}>
          <Table
            columns={columns}
            rowKey={(record) => record.id}
            scroll={{
              x: "max-content",
              y: 350,
            }}
            pagination={false}
            summary={(pageData) => {
              let totalAmount = 0,
                settled = 0,
                totalFee = 0,
                totalProcessingFee = 0,
                totalXpayFee = 0,
                totalAfterFeeAmount = 0;
              pageData.forEach(
                ({
                  amount,
                  status,
                  merchantFee,
                  processingFee,
                  xpayFee,
                  afterFeeAmount,
                }) => {
                  totalAmount += parseFloat(amount);
                  totalFee += parseFloat(merchantFee || 0);
                  totalProcessingFee += parseFloat(processingFee || 0);
                  totalAfterFeeAmount += parseFloat(afterFeeAmount || 0);
                  totalXpayFee += parseFloat(xpayFee || 0);
                  if (status === "SETTLED") settled += parseFloat(amount);
                },
              );

              return (
                <Table.Summary fixed>
                  <Table.Summary.Row>
                    <Table.Summary.Cell index={0}>
                      {data.length}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={1}>
                      <span className={`font-semibold ${bg_text}`}>
                        {moneyFormat(totalAmount)}
                      </span>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell className="flex flex-row" index={2}>
                      {loadingParkly ? (
                        <Spin size="small" />
                      ) : (
                        <div
                          className="border rounded-lg p-2 cursor-pointer"
                          onClick={() => setParklyDetailOpen(true)}
                        >
                          <img
                            src="/merchant/parkly.png"
                            alt="Parkly"
                            className="inline h-4 mr-1"
                          />
                          <span className="font-semibold text-blue-600">
                            {filteredParklyData
                              ? moneyFormat(filteredParklyData.total)
                              : "0"}
                          </span>
                        </div>
                      )}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={3}></Table.Summary.Cell>{" "}
                    <Table.Summary.Cell
                      index={4}
                      className="flex gap-2 flex-col text-xs"
                    >
                      <span className="font-semibold text-[#32B7C2]">
                        {moneyFormat(settled)}
                      </span>
                      <span className="font-semibold text-red-500">
                        {moneyFormat(totalAmount - settled)}
                      </span>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={5} />
                    <Table.Summary.Cell index={6}></Table.Summary.Cell>
                    <Table.Summary.Cell index={7}></Table.Summary.Cell>
                    <Table.Summary.Cell index={8}></Table.Summary.Cell>
                    <Table.Summary.Cell index={9} className={`${bg_text}`}>
                      {moneyFormat(totalFee)}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={10}></Table.Summary.Cell>
                    <Table.Summary.Cell
                      index={11}
                      className={`text-orange-500`}
                    >
                      {moneyFormat(totalXpayFee)}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={12}></Table.Summary.Cell>
                    <Table.Summary.Cell
                      index={13}
                      className={`text-orange-700`}
                    >
                      {moneyFormat(totalProcessingFee)}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell
                      index={13}
                      className={`${bg_text} font-bold`}
                    >
                      {moneyFormat(totalAfterFeeAmount)}
                    </Table.Summary.Cell>
                  </Table.Summary.Row>
                </Table.Summary>
              );
            }}
            dataSource={data}
          />
        </div>
        <div className="mt-4">
          <span className={`text-xl font-bold text-gray-800 ${bg_text}`}>
            Орлогын гүйлгээ
          </span>
          <div className={`${bg_button} mt-4 ${bg_shadow} rounded-xl`}>
            <Table
              columns={incomeColumns}
              rowKey={(record) => record.id}
              scroll={{
                x: "max-content",
                y: 100,
              }}
              pagination={false}
              dataSource={incomeData}
            />
          </div>
        </div>
      </div>
      <CheckPermission allow={3}>
        <div className="flex justify-end mt-4">
          <Popconfirm
            title="Эрсдэлтэйгээр өндөрлөх үү?"
            okText="forceSettle"
            onConfirm={forceSettle}
          >
            <Button
              className={`${bg_button} ${bg_shadow} text-white font-semibold`}
              style={{ minWidth: 120 }}
            >
              <span>Өндөрлүүлэх</span>
            </Button>
          </Popconfirm>
        </div>
      </CheckPermission>
      {pickBankTran && (
        <BankSelectModal
          open={pickBankTran}
          value={pickBankTran?.bankCode}
          save={saveTransaction}
          close={closeEdit}
        />
      )}
      <Modal
        title="Parkly дэлгэрэнгүй"
        open={parklyDetailOpen}
        onCancel={() => setParklyDetailOpen(false)}
        footer={null}
        width={460}
      >
        <div className="space-y-3">
          <div className="rounded-xl p-4 text-white bg-gradient-to-r from-sky-500 to-cyan-500 shadow-sm">
            <div className="flex items-center justify-between">
              <div className="text-sm font-medium text-sky-100">spay_grand_total</div>
              <img src="/merchant/parkly.png" alt="Parkly" className="h-5" />
            </div>
            <div className="text-2xl font-bold mt-1 tracking-wide">
              {moneyFormat(filteredParklyData?.spay_grand_total || 0)}
            </div>
            <div className="text-xs text-sky-100 mt-1">
              Transactions: {filteredParklyData?.total_transactions || 0}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-2">
            <div className="rounded-lg border border-slate-200 bg-slate-50 p-3">
              <div className="text-[11px] uppercase tracking-wider text-slate-500">POS total</div>
              <div className="text-sm font-semibold text-slate-800 mt-1">
                {moneyFormat(filteredParklyData?.pos_total || 0)}
              </div>
            </div>
            <div className="rounded-lg border border-slate-200 bg-slate-50 p-3">
              <div className="text-[11px] uppercase tracking-wider text-slate-500">Smartpay total</div>
              <div className="text-sm font-semibold text-slate-800 mt-1">
                {moneyFormat(filteredParklyData?.smartpay_total || 0)}
              </div>
            </div>
            <div className="rounded-lg border border-slate-200 bg-slate-50 p-3">
              <div className="text-[11px] uppercase tracking-wider text-slate-500">Cash total</div>
              <div className="text-sm font-semibold text-slate-800 mt-1">
                {moneyFormat(filteredParklyData?.cash_total || 0)}
              </div>
            </div>
            <div className="rounded-lg border border-slate-200 bg-slate-50 p-3">
              <div className="text-[11px] uppercase tracking-wider text-slate-500">Grand total</div>
              <div className="text-sm font-semibold text-slate-800 mt-1">
                {moneyFormat(filteredParklyData?.grand_total || 0)}
              </div>
            </div>
          </div>

          <div className="rounded-lg border border-cyan-100 bg-cyan-50 p-3 flex items-center justify-between">
            <span className="text-xs font-medium text-cyan-700">Status</span>
            <span className="text-xs font-semibold text-cyan-800">
              {filteredParklyData?.grand_total
                ? "Summary data loaded"
                : "No summary data"}
            </span>
          </div>
        </div>
      </Modal>
    </Modal>
  );
};

export default SettleTransactions;
